import { useState } from 'react';
import { PhoneCall, Mail, XCircle, Contact } from 'lucide-react';

const HelplinePopup = () => {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <>
            <div className="fixed bottom-2 right-4 z-50">
                <button
                    onClick={() => setShowPopup(!showPopup)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 hover:bg-blue-600 transition-all"
                >
                    <PhoneCall size={20} />
                    Helpline
                </button>

                {showPopup && (
                    <div className="absolute bottom-14 right-0 bg-white p-4 rounded-2xl shadow-2xl border border-blue-300 w-72">
                        <div className="flex justify-between items-center border-b border-gray-200 pb-2 mb-2">
                            <p className="text-lg font-semibold text-blue-500">Need Help?</p>
                            <XCircle
                                size={24}
                                className="text-red-500 cursor-pointer hover:text-red-600"
                                onClick={() => setShowPopup(false)}
                            />
                        </div>
                        <p className="text-sm text-gray-600 mb-2">Contact us at:</p>

                        <div className="flex items-center gap-3 mb-3">
                            <PhoneCall size={20} className="text-green-500" />
                            <a
                                href="tel:+917738355865"
                                className="text-blue-600 font-medium hover:underline"
                            >
                                +91 77383 55865
                            </a>
                        </div>

                        <div className="flex items-center gap-3 mb-3">
                            <Mail size={20} className="text-orange-500" />
                            <a
                                href="mailto:airaa@airaa.co.in"
                                className="text-blue-600 font-medium hover:underline"
                            >
                                airaa@airaa.co.in
                            </a>
                        </div>
                        <div className="flex items-center gap-3">
                            <Contact size={20} className="text-purple-500" />

                            <a href="/helpline" className="text-blue-600 font-medium hover:underline"> Emergency Contact (MEA)</a>
                        </div>
                    </div>
                )}
            </div>
        </>

    );
};

export default HelplinePopup;
